import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * возвращает callback для проверки активна ли сущность (url содержит данные сущности) из ProjectTree\
 * \
 * entityName - сущность (order/contract/etc)\
 * entityId - id сущности. или массив возможных 'приставок' (upload/edit/etc)
 */

export const useCheckActiveTreeItem = () => {
    const { pathname } = useLocation();

    return useCallback(
        ({ entityName, entityId }: { entityName: string; entityId?: string | number | string[] }) => {
            const fullEntityName = `${entityName}${entityId && !Array.isArray(entityId) ? `/${entityId}` : ''}`;

            const variants = [`${fullEntityName}/`, fullEntityName];

            if (Array.isArray(entityId)) {
                entityId.forEach((v) => {
                    variants.push(`${entityName}/${v}`, `${entityName}/${v}/`);
                });
            }

            return variants.some((v) => pathname.endsWith(v));
        },
        [pathname],
    );
};
